export const INITIAL_SCORE = 100;